import store from "./store"

export const selectCartQuantity = (store.select.checkout as any).quantity

export const selectCheckoutLink = (store.select.checkout as any).checkoutLink
